{
  "pt_BR": "cozinha",
  "cs_CZ": "kuchyne",
  "da_DK": "koekken",
  "de_DE": "kueche",
  "en_GB": "kitchen",
  "es_ES": "cocina",
  "fi_FI": "keittioe",
  "fr_FR": "cuisine",
  "it_IT": "cucina",
  "ja_JP": "kicchin",
  "ko_KR": "bujok",
  "nl_NL": "keuken",
  "nb_NO": "kjokken",
  "pl_PL": "kuchnia",
  "pt_PT": "cozinha",
  "ru_RU": "kuhnya",
  "sv_SE": "koek",
  "tr_TR": "mutfak",
  "zh_CN": "chu-fang"
}
